import Button from "ui/buttons/Button";
import Header from "./Header";

## Basic Usage

<Header
  left={<span style={{ fontWeight: 600 }}>Logo</span>}
  center={<span>Center Content</span>}
  right={<span>Right Content</span>}
/>

---

## Navigation Header

<Header
  left={<span style={{ fontWeight: 600, fontSize: "18px" }}>MyApp</span>}
  center={
    <nav style={{ display: "flex", gap: "1.5rem" }}>
      <a href="#" style={{ textDecoration: "none", color: "#3b82f6" }}>
        Home
      </a>
      <a href="#" style={{ textDecoration: "none", color: "#666" }}>
        Features
      </a>
      <a href="#" style={{ textDecoration: "none", color: "#666" }}>
        Pricing
      </a>
      <a href="#" style={{ textDecoration: "none", color: "#666" }}>
        About
      </a>
    </nav>
  }
  right={
    <div style={{ display: "flex", gap: "0.5rem" }}>
      <Button btnStyle="tertiary" btnSize="small">
        Log in
      </Button>
      <Button btnStyle="primary" btnSize="small">
        Sign up
      </Button>
    </div>
  }
/>

---

## Left-Aligned Content

<Header
  left={
    <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
      <span style={{ fontWeight: 600 }}>Brand</span>
      <nav style={{ display: "flex", gap: "1rem" }}>
        <a href="#" style={{ textDecoration: "none", color: "#666" }}>
          Docs
        </a>
        <a href="#" style={{ textDecoration: "none", color: "#666" }}>
          API
        </a>
        <a href="#" style={{ textDecoration: "none", color: "#666" }}>
          Support
        </a>
      </nav>
    </div>
  }
  right={
    <Button btnStyle="secondary" btnSize="small">
      Contact
    </Button>
  }
/>

---

## Dashboard Header

<Header
  left={
    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
      <span style={{ fontWeight: 600 }}>Dashboard</span>
      <span style={{ color: "#666" }}>/</span>
      <span style={{ color: "#666" }}>Projects</span>
    </div>
  }
  right={
    <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
      <span style={{ fontSize: "14px", color: "#666" }}>john@example.com</span>
      <div style={{ width: "32px", height: "32px", borderRadius: "50%", background: "#e5e5e5" }} />
    </div>
  }
/>

---

## Minimal Header

<Header
  left={<span style={{ fontWeight: 600, fontSize: "20px" }}>App</span>}
  right={<button style={{ background: "none", border: "none", cursor: "pointer", fontSize: "20px" }}>=</button>}
/>

---

## With Search

<Header
  left={<span style={{ fontWeight: 600 }}>Workspace</span>}
  center={
    <div style={{ width: "300px" }}>
      <input
        type="search"
        placeholder="Search..."
        style={{ width: "100%", padding: "6px 12px", borderRadius: "6px", border: "1px solid #e5e5e5" }}
      />
    </div>
  }
  right={
    <div style={{ display: "flex", gap: "0.5rem" }}>
      <Button btnStyle="tertiary" btnSize="small">
        Help
      </Button>
      <Button btnStyle="primary" btnSize="small">
        New
      </Button>
    </div>
  }
/>

---

## Custom Styling

<Header
  className="custom-header"
  left={<span style={{ fontWeight: 600, color: "white" }}>Dark Header</span>}
  center={<span style={{ color: "rgba(255,255,255,0.8)" }}>Centered</span>}
  right={<span style={{ color: "rgba(255,255,255,0.8)" }}>Right</span>}
/>

<style>{`
  .custom-header {
    background: #1a1a2e;
    padding: 1rem;
    border-radius: 8px;
  }
`}</style>
